"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migration_96_21_0 = void 0;
const echain_shared_igus_fundamentals_1 = require("@igus/echain-shared-igus-fundamentals");
const echain_shared_articles_oo_1 = require("@igus/echain-shared-articles-oo");
/**
 * tries to fix invalid ia alternation settings
 */
const migration_96_21_0 = (json) => {
    const ias = json.IAs;
    if (!(ias === null || ias === void 0 ? void 0 : ias.length))
        return json;
    if (json.IaArrangement === echain_shared_igus_fundamentals_1.IaArrangement.single) {
        const beats = echain_shared_articles_oo_1.IaBeatUtil.getAllBeats(ias);
        if (beats.length <= 1)
            return json;
        // there are more beats configured than possible.. so just put them all into one!
        ias.forEach((ia) => {
            ia.StartingAtNthKettenglied = beats[0].startingAt;
            ia.PerNthKettenglied = beats[0].perNth;
        });
        return json;
    }
    if (json.IaArrangement === echain_shared_igus_fundamentals_1.IaArrangement.evenOdd) {
        const possibleEvenOddBeats = echain_shared_articles_oo_1.IaBeatUtil.getEvenOddBeatsByKette(json.Kette);
        const configuredBeats = echain_shared_articles_oo_1.IaBeatUtil.getAllBeats(ias);
        const validConfiguredBeats = configuredBeats.filter((beat) => {
            const beatInEvenOddBeats = possibleEvenOddBeats.some((eob) => echain_shared_articles_oo_1.IaBeatUtil.isSameBeat(beat, eob));
            return beatInEvenOddBeats;
        });
        const anyInvalidBeatConfigured = configuredBeats.some((beat) => {
            return !possibleEvenOddBeats.some((eob) => {
                return echain_shared_articles_oo_1.IaBeatUtil.isSameBeat(beat, eob);
            });
        });
        if (!anyInvalidBeatConfigured)
            return json;
        const repairBeat = 
        // more than two valid beats?
        validConfiguredBeats.length > 1
            ? // then just take the second one though..
                validConfiguredBeats[1]
            : // if not, find a beat which is not yet configured
                possibleEvenOddBeats.find((eob) => {
                    return !configuredBeats.some((beat) => echain_shared_articles_oo_1.IaBeatUtil.isSameBeat(eob, beat));
                });
        if (!repairBeat)
            return json;
        ias.forEach((ia) => {
            const isIaBeatValid = possibleEvenOddBeats.some((eob) => echain_shared_articles_oo_1.IaBeatUtil.isInBeat(ia, eob));
            if (isIaBeatValid)
                return;
            ia.StartingAtNthKettenglied = repairBeat.startingAt;
            ia.PerNthKettenglied = repairBeat.perNth;
        });
        return json;
    }
    return json;
};
exports.migration_96_21_0 = migration_96_21_0;
//# sourceMappingURL=migration_96_21_0.js.map